app.component("patientDiagnosisList", {
    templateUrl: "app/src/js/components/patientDiagnosis/patientDiagnosisList.html",
    controller: "patientDiagnosisListController",
    bindings: {
        data: "=",
        diagnosisType: "@",
        acceptDiagnosis: "=",
        rejectDiagnosis: "=",
        editDiagnosis: "=",
        hideAiSuggested: "<",
    },
});

app.controller("patientDiagnosisListController", [
    "$scope",
    "CurrentPatient",
    "DiagnosisAPI",
    "InfoPopoverHover",
    function ($scope, CurrentPatient, DiagnosisAPI, InfoPopoverHover) {
        $scope.CP = CurrentPatient;
        $scope.DiagnosisAPI = DiagnosisAPI;

        $scope.$watch("$ctrl.data", function (newValue) {
            if (!newValue) return;

            // Unverified AI suggestions (is_human_verified === 'PENDING') are only shown where the
            // host provides accept/reject handlers; screens like the referral opt out via hide-ai-suggested.
            const isVisible = item => item && item.status === 'ACTIVE'
                && !($scope.$ctrl.hideAiSuggested && item.is_human_verified === 'PENDING');

            if ($scope.$ctrl.diagnosisType === 'ocular') {
                // Each eye is listed independently of the other - no attempt to line up rows by date/type.
                const odItems = DiagnosisAPI.sortDiagnosisItems(newValue.map(row => row.od).filter(isVisible));
                const osItems = DiagnosisAPI.sortDiagnosisItems(newValue.map(row => row.os).filter(isVisible));

                const rows = [];
                for (let i = 0; i < Math.max(odItems.length, osItems.length); i++) {
                    rows.push({ od: odItems[i] || null, os: osItems[i] || null });
                }
                $scope.filteredData = rows;
            } else {
                $scope.filteredData = DiagnosisAPI.sortDiagnosisItems(newValue.filter(isVisible));
            }
        }, true);

        InfoPopoverHover.attach($scope);
    },
]);